var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.drug.infoPrices, function (info) {
      return _c("div", [
        _c("p", [
          _c("strong", [_vm._v(_vm._s(info.supplier.title))]),
          _vm._v(" - цена: "),
          _c("strong", [_vm._v(_vm._s(info.price))]),
        ]),
        _vm._v(" "),
        info?.extra_data?.min_price
          ? _c("p", [
              _vm._v("минимальная цена:\n      "),
              _c("strong", [_vm._v(_vm._s(info.extra_data.min_price))]),
            ])
          : _vm._e(),
        _vm._v(" "),
        info?.extra_data?.in_stores
          ? _c("p", [
              _vm._v("в наличии в аптеках:\n      "),
              _c("strong", [_vm._v(_vm._s(info.extra_data.in_stores))]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "text-muted" }, [
          _vm._v(_vm._s(_vm.printDate(info.updated_at))),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }